module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921034149_T.221e3c9d.jpg";